import { type TFunction } from 'i18next';

import { AggregationType } from 'src/services/insight-cards/types';

export const getEventBasedAggregationTypeOptions = (
  t: TFunction<'solve-insights'>,
) =>
  [
    {
      description: t('cards.aggregation.uniqueConversationsDescription'),
      label: t('cards.aggregation.uniqueConversations'),
      value: 'unique',
    },
    {
      description: t('cards.aggregation.eventTotalsDescription'),
      label: t('cards.aggregation.eventTotals'),
      value: 'total',
    },
    {
      description: t('cards.aggregation.sumDescription'),
      label: t('cards.aggregation.sum'),
      value: 'sum',
    },
    {
      description: t('cards.aggregation.averageDescription'),
      label: t('cards.aggregation.average'),
      value: 'avg',
    },
  ] as const satisfies {
    description: string;
    label: string;
    value: AggregationType;
  }[];

export const getFunnelAggregationTypeOptions = (
  t: TFunction<'solve-insights'>,
) =>
  [
    {
      description: t('cards.aggregation.conversionDescription'),
      label: t('cards.aggregation.conversion'),
      value: 'conversion',
    },
  ] as const satisfies {
    description: string;
    label: string;
    value: AggregationType;
  }[];
